import { styled } from '@mui/material/styles';
import { Input } from '@components/Input';
import { Select } from '@components/Select';
import { useTranslation } from '@hooks';
import DynamicFieldsButton from './DynamicFieldsButton';

const Panel = styled('div')({
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});

const SettingsPanel = ({
    name,
    subject,
    preheader,
    brandId,
    brands,
    isView,
    onChangeName,
    onChangeSubject,
    onChangePreheader,
    onSelectBrand,
}) => {
    const { t } = useTranslation();

    return (
        <Panel>
            <Input
                label={t('TemplateLibrary.templateName')}
                required
                fullWidth
                disabled={isView}
                inputProps={{
                    value: name,
                    onChange: e => onChangeName(e.target.value),
                }}
            />
            {(brands || []).length > 0 && (
                <Select
                    label={t('common.brand')}
                    fullWidth
                    disabled={isView}
                    value={brandId}
                    onChange={({ target: { value } }) => onSelectBrand(value)}
                    options={[
                        { value: '', label: t('TemplateLibrary.noBrand') },
                        ...brands.map(brand => ({ value: brand.id, label: brand.title })),
                    ]}
                />
            )}
            <Input
                label={t('common.subject')}
                fullWidth
                disabled={isView}
                inputProps={{
                    value: subject,
                    onChange: e => onChangeSubject(e.target.value),
                }}
                addonWithoutWrapper
                addonComponent={
                    <DynamicFieldsButton disabled={isView} onInsert={token => onChangeSubject(`${subject}${token}`)} />
                }
            />
            <Input
                label={t('TemplateLibrary.preheader')}
                fullWidth
                multiline
                minRows={2}
                disabled={isView}
                inputProps={{
                    value: preheader,
                    onChange: e => onChangePreheader(e.target.value),
                }}
                toolbar={
                    <DynamicFieldsButton
                        disabled={isView}
                        // The positioning wrapper extends 16px below the field border (the
                        // form control's helper-text reserve) — offset past it so the glyph
                        // keeps a 12px inset inside the field.
                        btnStyles={{ position: 'absolute', left: 8, bottom: 24 }}
                        onInsert={token => onChangePreheader(`${preheader}${token}`)}
                    />
                }
            />
        </Panel>
    );
};

export default SettingsPanel;
